import isbot from "isbot";

// Google crawlers by name (Merchant Center checks pages as Storebot-Google); other bots by their own token.
const GOOGLE_CRAWLER =
  /Storebot-Google|Googlebot-Image|Googlebot|Google-InspectionTool|AdsBot-Google-Mobile|AdsBot-Google|GoogleOther|Mediapartners-Google|FeedFetcher-Google/;
const BOT_TOKEN = /[\w.-]*(?:bot|crawler|spider)\b[\w.-]*/i;

// Crawler name for logs and Sentry, "no" for a real visitor; isbot() decides, the regexes only name it.
export const crawlerTag = (userAgent?: string | null) => {
  if (!userAgent || !isbot(userAgent)) return "no";
  return userAgent.match(GOOGLE_CRAWLER)?.[0] ?? userAgent.match(BOT_TOKEN)?.[0] ?? "other";
};
